(() => {
  'use strict';

  const currentScript = document.currentScript;
  if (currentScript && currentScript.src) {
    const coreUrl =
      currentScript.dataset.n9CoreSrc ||
      currentScript.src.replace('n9-mobile-menu-v2.js', 'n9-mobile-menu-v2-core.js');

    const guidesUrl = currentScript.dataset.n9GuidesSrc
      ? new URL(currentScript.dataset.n9GuidesSrc, window.location.href)
      : new URL(currentScript.src.replace('n9-mobile-menu-v2.js', 'n9-guides-menu-v2.js'), window.location.href);

    const script = document.createElement('script');
    script.src = coreUrl;
    script.async = false;
    script.onload = () => {
      const guidesScript = document.createElement('script');
      guidesScript.src = guidesUrl.toString();
      guidesScript.async = false;
      document.head.appendChild(guidesScript);
    };
    document.head.appendChild(script);
  }

  function applyRegionalUi() {
    const country = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (!country || country === 'US') return;

    document.querySelectorAll('a[href*="/pages/data-sharing-opt-out"]').forEach((link) => {
      const item = link.closest('li');
      if (item) item.style.display = 'none';
      else link.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRegionalUi);
  } else {
    applyRegionalUi();
  }

  document.addEventListener('shopify:section:load', applyRegionalUi);
})();
